import {QRCode} from 'react-qr-svg'

import {useOrderLoyaltyInfo} from '../hooks/useLoyaltyInfo.royalty'

import addToAppleWallet from './addToAppleWallet.svg'
import addToGoogleWallet from './addToGoogleWallet.svg'

export interface Props {
  card: ReturnType<typeof useOrderLoyaltyInfo>
}

function getPlatform(): 'apple' | 'google' | 'other' {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1) {
    return 'apple'
  }
  if (ua.indexOf('android') !== -1) {
    return 'google'
  }
  return 'other'
}

export default function AddToWallets(props: Props) {
  const {card} = props
  const platform = getPlatform()

  if (platform === 'apple') {
    return (
      <div className="space-y-2 text-center">
        <a href={card.downloadAppleURL} className="">
          <img src={addToAppleWallet} alt="Add to Apple Wallet" className="mx-auto w-48" />
        </a>

        <div className="text-sm">
          Guarda tu tarjeta de lealtad en tu billetera digital para que puedas acceder a ella
        </div>
      </div>
    )
  }

  if (platform === 'google') {
    return (
      <div className="space-y-2 text-center">
        <a href={card.downloadGoogleURL} className="">
          <img src={addToGoogleWallet} alt="Add to Google Wallet" className="mx-auto w-48" />
        </a>

        <div className="text-sm">
          Guarda tu tarjeta de lealtad en tu billetera digital para que puedas acceder a ella
        </div>
      </div>
    )
  }

  return (
    <div className="flex w-full items-start space-x-2">
      <QRCode value={card.downloadURL} className="flex-1 border-2 border-white rounded-md" />
      <div className="flex-1 space-y-2">
        <div className="text-xs">
          Escanea este código QR para agregar tu tarjeta de lealtad a tu billetera digital
        </div>
        <div className="space-y-1">
          <a href={card.downloadAppleURL} className="block">
            <img src={addToAppleWallet} alt="Add to Apple Wallet" className="h-10" />
          </a>
          <a href={card.downloadGoogleURL} className="block">
            <img src={addToGoogleWallet} alt="Add to Google Wallet" className="h-10" />
          </a>
        </div>
      </div>
    </div>
  )
}
